import Vue from 'vue'
import commonJs from "@/utils/common"
import Router from "@/router"

Vue.directive('data', {
  bind: function (el, binding, vnode) {
    if (!el["vData"]) el["vData"] = {};
    el["vData"][binding.arg] = binding.value;
  }
})

Vue.directive('can', {
  bind: function (el, binding, vnode) {



  }
})

//小数点保留后两位
Vue.directive('snum', {
  bind: function (el, binding, vnode) {
    // console.log('num-binding', binding)
    // console.log('num-vnode', vnode)
    // console.log('num-Router', Router.history.current)
    let ele = el.querySelector('input');
    // console.log('num-ele', ele)
    ele.oninput = function () {
      var data = ele.value.toString();
      data = data.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, "$1");
      ele.value = data;
      vnode.data.model.callback(data); //更新 v-model 绑定的值
    }
  }
})

//整数
Vue.directive('int', {
  bind: function (el, binding, vnode) {
    let ele = el.querySelector('input');
    ele.oninput = function () {
      var data = ele.value.toString();
      data = data.replace(/[^\d]/g, "");
      ele.value = data;
      vnode.data.model.callback(data); //更新 v-model 绑定的值
    }
  }
})

Vue.directive('nobubble', {
  bind: function (el, binding, vnode) {
    el.addEventListener("click", function (e) {
      console.log('vnode', vnode);
      var inputEle = vnode.context.inputEle;
      if (inputEle) {
        var child = inputEle.firstElementChild;
        if (child) {
          child.focus();
          child.selectionStart = child.value.length;
        }
      }
      e.stopPropagation();
    });
  },
})

Vue.directive('xinput', {
  bind: function (el, binding, vnode) {
    el.addEventListener('input', function (e) {
      var eventName = 'xinput';
      var eventData = { val: e.data, el: el }
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit(eventName, eventData); // use {detail:} to be uniform
      } else {
        vnode.elm.dispatchEvent(new CustomEvent(eventName, eventData));
      }
    })
    el.addEventListener('dblclick', function (e) {
      var eventName = 'xinput';
      var eventData = { val: "", el: el }
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit(eventName, eventData); // use {detail:} to be uniform
      } else {
        vnode.elm.dispatchEvent(new CustomEvent(eventName, eventData));
      }
    })
  }
})

Vue.directive('keymove', {
  bind: function (el, binding, vnode, oldVnode) {
    // console.log('bind', vnode, binding)
    // var current = 0;
    var tb_children = vnode.elm.children;
    var wrapper = null;
    for (let i = 0; i < tb_children.length; i++) {
      if (tb_children[i].className.indexOf("el-table__body-wrapper") != -1) wrapper = tb_children[i];
    }

    el.onkeyup = function (e) {
      // current++;
      // console.log('current', current)
      setMove(e);
    }

    function setMove(e) {
      // if (e.ctrlKey) console.log('onkeyup', e);

      var keys = ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Enter", "Home", "End"];
      if (keys.indexOf(e.key) == -1) return;

      var td = e.path.find(x => x.localName == "td");
      var tr = e.path.find(x => x.localName == "tr");
      var names = td.className.split('_');
      var tb_name = names[0] + '_' + names[1];
      // console.log('tb_name', tb_name)
      var cells1 = wrapper.querySelectorAll('.cell:not(.el-tooltip)');
      // console.log('cells1', cells1);
      var cells2 = [];

      if (e.ctrlKey) {
        var node1 = e.target.parentNode;
        try {
          if (node1.__vue__.$parent.hidePicker != undefined) {
            node1.__vue__.$parent.hidePicker();
          }
          var node2 = node1.parentNode;
          if (node2.__vue__ != undefined) node2.__vue__.blur();
        } catch (error) {
          // console.log('try', error)
        }
        // console.log('wrapper', wrapper);

        cells2 = (Array(...cells1)).filter(x => x.parentElement.className.indexOf(tb_name) != -1);
        // console.log('cells2', cells2);
      }

      if (e.ctrlKey && e.key == "ArrowUp") {
        // td.setAttribute('style', '')
        if (tr.previousElementSibling == null) return;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var child1 = tr.previousElementSibling.children;
        var child2 = Array(...child1).find(x => x.className == td.className);
        child2.setAttribute('style', 'background-color: #00996621;');
        var cell = child2.children[0];
        MoveAction(cell);
      }
      if (e.ctrlKey && e.key == "ArrowDown") {
        // td.setAttribute('style', '')
        if (tr.nextElementSibling == null) return;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var child1 = tr.nextSibling.children;
        var child2 = Array(...child1).find(x => x.className == td.className);
        child2.setAttribute('style', 'background-color: #00996621;');
        var cell = child2.children[0];
        MoveAction(cell);
      }
      if (e.ctrlKey && e.key == "ArrowLeft") {
        // console.log('prev', td.previousSibling);
        // td.setAttribute('style', '')
        if (td.previousSibling == null) return;
        if (wrapper.scrollLeft >= 0) wrapper.scrollLeft -= td.scrollWidth;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var cell = td.previousSibling.children[0];
        td.previousSibling.setAttribute('style', 'background-color: #00996621;')
        MoveAction(cell);
      }
      if (e.ctrlKey && e.key == "ArrowRight") {
        // td.setAttribute('style', '');
        if (td.nextSibling == null) return;
        if (wrapper.scrollLeft < wrapper.scrollWidth) wrapper.scrollLeft += td.scrollWidth;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var cell = td.nextSibling.children[0];
        td.nextSibling.setAttribute('style', 'background-color: #00996621;')
        MoveAction(cell);
      }
      if (e.ctrlKey && e.key == "Enter") {
        if (tr.nextElementSibling == null) {
          var expression = binding.expression;
          if (vnode.context[expression] != undefined) vnode.context[expression]();
        }
      }
      if (e.ctrlKey && e.key == "Home") {
        wrapper.scrollLeft = 0;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var child = tr.children[0];
        child.setAttribute('style', 'background-color: #00996621;');
        var cell = child.children[0];
        MoveAction(cell);
      }
      if (e.ctrlKey && e.key == "End") {
        wrapper.scrollLeft = wrapper.scrollWidth;
        for (let i = 0; i < cells2.length; i++) {
          cells2[i].parentElement.setAttribute('style', '');
        }
        var length = tr.children.length;
        var child = tr.children[length - 1];
        child.setAttribute('style', 'background-color: #00996621;');
        var cell = child.children[0];
        MoveAction(cell);
      }
    }
    function MoveAction(cell) {
      // console.log('wrapper', wrapper.scrollLeft, wrapper)
      var cell_child = cell.children[0];
      // console.log('cell_child', cell_child)
      if (cell_child == undefined) {
        cell.setAttribute('tabindex', -1);
        cell.focus();
        return;
      }
      var class_name = cell_child.className;
      // console.log('class_name', class_name);
      if (class_name.indexOf('is-disabled') == -1) {
        if (class_name.indexOf("el-input") != -1 && class_name.indexOf("el-date-editor") != -1) {
          // console.log('时间选择器')
          var inner = cell_child.children[0];
          inner.focus();
          // console.log('__vue__', cell_child.__vue__)
          // cell_child.__vue__.hidePicker();
          try {
            // console.log('try')
            cell_child.__vue__.hidePicker();
            cell_child.__vue__.pickerVisible = false;
          } catch (error) {
            // console.log('error')
            cell_child.__vue__.$parent.hidePicker();
            cell_child.__vue__.$parent.pickerVisible = false;
          }
        } else if (class_name.indexOf("el-select") != -1) {
          // console.log('下拉框');
          cell_child.click();
        } else if (class_name.indexOf("el-input") != -1) {
          // console.log('输入框');
          var inner = cell_child.children[0];
          inner.focus();
        } else if (class_name.indexOf("complexSelect") != -1) {
          // console.log('复杂选择');
          var span = cell_child.children[0];
          var complexSelect = Array(...span.children).find(x => x.className.indexOf("el-input") != -1);
          // for (let i = 0; i < span.children.length; i++) {
          //   if (span.children[i].className.indexOf("el-input") != -1) {
          //     complexSelect = span.children[i]
          //   }
          // }
          // console.log('complex', complexSelect);
          complexSelect.focus();
        } else {
          cell.setAttribute('tabindex', -1);
          cell.focus();
        }
      } else {
        cell.setAttribute('tabindex', -1);
        cell.focus();
      }
    }
  },
  unbind: function (el, binding, vnode) {
    console.log('unbind')
  }
})